module.exports = __webpack_public_path__ + "static/media/img3.3c76e746.jpg";